<template>
    <div class="d-inline-block">
        <b-button variant="pgiBtn" :class="buttonClass" v-b-tooltip.hover.top :title="tooltip" @click="showModal = true">
            <i class="fa fa-eye" :class="{ 'mr-1': buttonLabel }"></i>{{ buttonLabel }}
        </b-button>

        <b-modal v-model="showModal" :title="title" size="lg" centered hide-footer>
            <div v-if="groups.length == 0" class="text-center py-3">Tidak ada foto/video</div>
            <div v-for="group in groups" :key="group.label" class="mb-4">
                <h6 class="form-title mb-2">{{ group.label }} ({{ group.urls.length }})</h6>
                <div class="pengiriman-gallery">
                    <a v-for="url in group.urls" :key="url" :href="url" target="_blank" class="pengiriman-item">
                        <video v-if="group.isVideo || videoUrls.includes(url)" :src="url" muted preload="metadata"></video>
                        <img v-else :src="url" alt="Foto Pengiriman" @error="videoUrls.push(url)">
                    </a>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'ModalFotoPengiriman',
    props: {
        groups: { type: Array, default: () => [] },
        title: { type: String, default: 'Foto/Video Pengiriman' },
        buttonLabel: { type: String, default: 'Lihat Foto/Video Pengiriman' },
        buttonClass: { type: String, default: '' },
        tooltip: { type: String, default: '' },
    },
    data() {
        return {
            showModal: false,
            videoUrls: [],
        }
    },
}
</script>

<style scoped>
.pengiriman-gallery {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}
.pengiriman-item {
    display: block;
    border: 1px solid #e2e5e9;
    border-radius: 8px;
    overflow: hidden;
    background: #f8f9fa;
}
.pengiriman-item img,
.pengiriman-item video {
    display: block;
    width: 100%;
    height: 160px;
    object-fit: cover;
}
@media (max-width: 576px) {
    .pengiriman-gallery {
        grid-template-columns: repeat(2, 1fr);
    }
}
</style>
